import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import Breadcrumb from "../components/Breadcrumb";
// import FooterOne from "../components/FooterOne";
// import NavBar from "../components/NavBar";
import ServiceDetailsArea from "../components/ServiceDetailsArea";

import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const ServiceDetails = () => {
  return (
    <>
      <SEO canonical="/service-details" {...PAGES["/service-details"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Service Details"} />

      {/* Service Details Area */}
      <ServiceDetailsArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default ServiceDetails;
